<template>
	<div class="formulate-address-select">
		<v-select
			ref="select"
			:class="`formulate-input-element formulate-input-element--${context.type}`"
			:data-type="context.type"
			v-model="selectedAddress"
			:options="options"
			:reduce="(x) => x.value"
			v-bind="context.attrs"
			:filterable="false"
			label="label"
			@close="onClose"
			@search="onSearch"
		>
			<template #selected-option-container="{option}">
				<span class="vs__selected" v-html="option.label"></span>
			</template>

			<template #option="{label}">
				<div class="formulate-option-selector__option">
					<span v-html="label" class="option-label"></span>
				</div>
			</template>
		</v-select>
		<input ref="addressfield" class="noRender">
	</div>
</template>


<script src="./FormulateAddress.js"></script>
